import EventEmitter from 'eventemitter3';
import createjs from 'preload-js';

import { CONFIG } from '../consts';

export const LoaderEvent = {
    LOADING: '__le_loading',
    MEDIA_LOADED: '__le_loader_loaded'
};

class Loader extends EventEmitter {
    constructor() {
        super();

        this.isLoading = false;
        this.assets = {};
        this.percent = 0;
        this.loadingSteps = {
            response: 20
        };
        this._manifest = [];

        bindAll(this, [
            '_updatePercent',
            '_progressHandler',
            '_fileloadHandler',
            '_completeHandler',
            '_errorHandler'
        ]);

        this._retrieveDom();
        this.init();
        this.bind();
        this.show();
    }

    _retrieveDom() {
        this._dom = {
            container: document.body.querySelector('.loader')
        };
    }

    init() {
        this.queue = new createjs.LoadQueue(true);
        this.queue.setMaxConnections(8);
    }

    bind() {
        this.queue.on('progress', this._progressHandler, this);
        this.queue.on('fileload', this._fileloadHandler, this);
        this.queue.on('complete', this._completeHandler, this);
        this.queue.on('error', this._errorHandler, this);
    }

    unbind() {
        this.queue.off('progress', this._progressHandler, this);
        this.queue.off('fileload', this._fileloadHandler, this);
        this.queue.off('complete', this._completeHandler, this);
        this.queue.off('error', this._errorHandler, this);
    }

    show() {
        this._showTl = new TimelineMax();
    }

    hide() {
        this._hideTl = new TimelineMax({
            onComplete: () => {
                this.percent = 0;
                this.emit(LoaderEvent.MEDIA_LOADED);
            }
        });
        if (this._dom.container) {
            this._hideTl.to(this._dom.container, 0.5, { autoAlpha: 0 });
        }
    }

    preloadMedia(container) {
        this._manifest = [];

        const media = [...container.querySelectorAll('[data-background]'), ...container.querySelectorAll('[data-src]')];
        for (let i = 0, j = media.length; i < j; i++) {
            const medium = media[i];
            const src = (medium.getAttribute('data-background')) ? medium.getAttribute('data-background') : medium.getAttribute('data-src');
            const id = medium.getAttribute('data-id') || 'img-' + i;
            const isBackground = (medium.getAttribute('data-background')) ? true : false;
            
            this._manifest.push({
                id,
                target: medium,
                src,
                isBackground,
                crossOrigin: true
            });
        }

        if (this._manifest.length > 0)
            this.queue.loadManifest(this._manifest);
        else
            this._completeHandler();

        this.isLoading = true;
    }

    setPercent(percent = 0) {
        TweenMax.to(this, .3, {
            percent,
            onUpdate: this._updatePercent
        });
    }

    _updatePercent() {
        this.emit(LoaderEvent.LOADING, this.percent);

        if (this.percent === 100) {
            this.isLoading = false;
            this.hide();
        }
    }

    AJAXresponseHandler() {
        if (CONFIG.IS_LAZY_LOADING)
            this._completeHandler();
        else
            this.setPercent(this.loadingSteps.response);
    }

    _progressHandler(event) {
        this.setPercent(this.loadingSteps.response + event.progress * (100 - this.loadingSteps.response));
    }

    _fileloadHandler(event) {
        if (event.item.isBackground)
            event.item.target.style.backgroundImage = 'url(' + event.item.src + ')';
        else
            event.item.target.setAttribute('src', event.item.src);
        event.item.target.classList.add('media-loaded');

        this.assets[event.item.id] = event.item.target;
    }

    _completeHandler(event) {
        this.setPercent(100);
    }

    _errorHandler(event) {
        console.error(event);
    }
}

export default new Loader();



// WEBPACK FOOTER //
// ./src/js/helpers/loader.js